export type OptionType = {
  icon?: JSX.Element;
  value: string;
  label: string;
};

export const PropertyLocationOptions: OptionType[] = [
  {
    value: "england",
    label: "England",
  },
  {
    value: "scotland",
    label: "Scotland",
  },
  {
    value: "wales",
    label: "Wales",
  },
  {
    value: "northern_ireland",
    label: "Northern Ireland",
  },
];

export const PropertyFreeholdLeaseholdOptions: OptionType[] = [
  {
    value: "freehold",
    label: "Freehold",
  },
  {
    value: "leasehold",
    label: "Leasehold",
  },
];

export const FloorAreaOptions = [
  "Don't know",
  "<50",
  "50-80",
  "80-100",
  "100-150",
  "150+",
];
export const YearBuiltOptions = [
  "Don't know",
  "Before 1900",
  "1900-1949",
  "1950-1979",
  "1980-1999",
  "2000-2009",
  "2010-2019",
  "2020+",
];

export const CouncilTaxOptions = [
  "Don't know",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
];
export const EpcOptions = ["Don't know", "A", "B", "C", "D", "E", "F", "G"];
export const PrimaryHeatingOptions = [
  "Don't know",
  "Gas",
  "Electric",
  "Oil",
  "Heat Pump",
  "Other",
];

export const PropertyLeaseholdIssuesOptions: OptionType[] = [
  {
    label: "EWS1 Issues",
    value: "ews1_issues",
  },
  {
    label: "Short Lease",
    value: "short_lease",
  },
  {
    label: "Doubling Ground Rent",
    value: "doubling_ground_rent",
  },
  {
    label: "Absent Freeholder",
    value: "absent_freeholder",
  },
  {
    label: "Section 20 Notice",
    value: "section_20_notice",
  },
  {
    label: "No Leasehold Issues",
    value: "no_issues",
  },
];

export const PropertyTypeOptions: OptionType[] = [
  {
    value: "detached",
    label: "Detached",
  },
  {
    value: "semi-detached",
    label: "Semi-Detached",
  },
  {
    value: "bungalow",
    label: "Bungalow",
  },
  {
    value: "terraced",
    label: "Terraced",
  },
  {
    value: "apartment",
    label: "Apartment",
  },
  {
    value: "maisonette",
    label: "Maisonette",
  },
];

export const PropertyInheritanceOptions: OptionType[] = [
  {
    value: "own_home",
    label: "Your Home",
  },
  {
    value: "inheritance",
    label: "Inheritance",
  },
  {
    value: "investment",
    label: "Investment",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const PropertyIssuesOptions: OptionType[] = [
  {
    value: "no",
    label: "No",
  },
  {
    value: "yes",
    label: "Yes",
  },
];

export const PropertyBedOptions: OptionType[] = [
  {
    value: "1",
    label: "1",
  },
  {
    value: "2",
    label: "2",
  },
  {
    value: "3",
    label: "3",
  },
  {
    value: "4",
    label: "4",
  },
  {
    value: "5+",
    label: "5+",
  },
];

export const PropertyTenantedSaleOptions: OptionType[] = [
  {
    value: "tenanted",
    label: "Tenanted",
  },
  {
    value: "vacant",
    label: "Vacant",
  },
  {
    value: "flexible",
    label: "I'm Flexible",
  },
];

export const OwnerOccupationOptions: OptionType[] = [
  {
    value: "owner_occupied",
    label: "I'm living there",
  },
  {
    value: "empty",
    label: "It's empty",
  },
  {
    value: "tenanted",
    label: "It's tenanted",
  },
];

export const CashSaleReason: OptionType[] = [
  {
    label: "Fast Sale",
    value: "fast_sale",
  },
  {
    label: "Certain Sale",
    value: "certain_sale",
  },
  {
    label: "Property Issues",
    value: "property_issues",
  },
];

export const PropertySaleReasonOptions: OptionType[] = [
  {
    label: "Chain repair",
    value: "chain_repair",
  },
  {
    label: "Purchase of a new build property",
    value: "purchase_of_new_build",
  },
  {
    label: "Upsizing",
    value: "upsizing",
  },
  {
    label: "Downsizing",
    value: "downsizing",
  },
  {
    label: "Moving into rented",
    value: "moving_into_rented",
  },
  {
    label: "Unwanted buy to let",
    value: "unwanted_buy_to_let",
  },
  {
    label: "Inheritance",
    value: "inheritance",
  },
  {
    label: "Problem property",
    value: "problem_property",
  },
  {
    label: "Financial difficulties",
    value: "financial_difficulties",
  },
  {
    label: "Other",
    value: "other",
  },
];

export const PropertySaleStatusOptions: OptionType[] = [
  {
    value: "not_on_market",
    label: "Not on the market",
  },
  {
    value: "on_market_sale_not_agreed",
    label: "On the market but no sale agreed yet",
  },
  {
    value: "sale_fallen_through",
    label: "Sale fallen through",
  },
  {
    value: "sale_might_fall_through",
    label: "Sale might fall through",
  },
];

export const PropertyCurrentConditionOptions: OptionType[] = [
  {
    label: "Poor Condition",
    value: "poor",
  },
  {
    label: "Fair Condition",
    value: "fair",
  },
  {
    label: "Excellent Condition",
    value: "excellent",
  },
];

export const PropertyBuyingSellingOptions: OptionType[] = [
  {
    label: "I'm just selling",
    value: "just_selling",
  },
  {
    label: "I'm in a chain",
    value: "in_a_chain",
  },
];

export const PropertyTimeframeOptions: OptionType[] = [
  {
    label: "Within one month",
    value: "within_one_month",
  },
  {
    label: "1 - 2 months",
    value: "1_2_months",
  },
  {
    label: "More than 2 months",
    value: "more_than_2_months",
  },
];

export const PropertySeriousIssuesOptions: OptionType[] = [
  {
    label: "Japanese Knotweed",
    value: "japanese_knotweed",
  },
  {
    label: "Subsidence",
    value: "subsidence",
  },
  {
    label: "Spray Foam Insulation",
    value: "spray_foam_insulation",
  },
  {
    label: "Mine Shaft",
    value: "mine_shaft",
  },
  {
    label: "Non Standard Construction",
    value: "non_standard_construction",
  },
  {
    label: "Lease Issues",
    value: "lease_issues",
  },
  {
    label: "Title Issues",
    value: "title_issues",
  },
  {
    label: "Other",
    value: "other",
  },
];

export const YesNoOptions: OptionType[] = [
  {
    value: "yes",
    label: "Yes",
  },
  {
    value: "no",
    label: "No",
  },
];

export const EstimatedValueOptions: OptionType[] = [
  {
    value: "10000-150000",
    label: "£10,000 - £150,000",
  },
  {
    value: "151000-300000",
    label: "£151,000 - £300,000",
  },
  {
    value: "301000-600000",
    label: "£301,000 - £600,000",
  },
  {
    value: "600000+",
    label: "£600,000+",
  },
];
